import { render, staticRenderFns } from "./ServiceOne.vue?vue&type=template&id=0fe5f774"
import script from "./ServiceOne.vue?vue&type=script&lang=js"
export * from "./ServiceOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports